import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Chart as ChartJS, ArcElement, Tooltip, Legend, CategoryScale, LinearScale, BarElement, Title as ChartTitle,
    PointElement, // <--- НОВЫЙ
    LineElement   // <--- НОВЫЙ
} from 'chart.js';
import { Pie, Bar } from 'react-chartjs-2';
import Card from '../common/Card/Card';
import styles from './ChartCard.module.css';

// Регистрируем все необходимые компоненты Chart.js
ChartJS.register(ArcElement, Tooltip, Legend, CategoryScale, LinearScale, BarElement, ChartTitle,
PointElement, // <--- НОВЫЙ
    LineElement   // <--- НОВЫЙ
);

const ChartCard = ({ questionStats }) => {
    const { question_text, stats } = questionStats;

    const chartData = {
        labels: stats.labels,
        datasets: [{
            label: '# of votes',
            data: stats.values,
            backgroundColor: [
                'rgba(54, 162, 235, 0.6)', 'rgba(255, 99, 132, 0.6)',
                'rgba(255, 206, 86, 0.6)', 'rgba(75, 192, 192, 0.6)',
                'rgba(153, 102, 255, 0.6)', 'rgba(255, 159, 64, 0.6)',
                'rgba(99, 255, 132, 0.6)', 'rgba(255, 99, 255, 0.6)'
            ],
            borderColor: [
                'rgba(54, 162, 235, 1)', 'rgba(255, 99, 132, 1)',
                'rgba(255, 206, 86, 1)', 'rgba(75, 192, 192, 1)',
                'rgba(153, 102, 255, 1)', 'rgba(255, 159, 64, 1)',
                'rgba(99, 255, 132, 1)', 'rgba(255, 99, 255, 1)'
            ],
            borderWidth: 1,
        }],
    };

    const options1 = { responsive: true, maintainAspectRatio: false };
    const options = {
        responsive: true,
        maintainAspectRatio: false, // Важно для корректного размера в контейнере
        plugins: {
            legend: {
                // Для Bar-чартов лучше скрыть легенду, если она одна
                display: stats.type === 'pie',
            },
        },
    };

    const renderChart = () => {
        if ((stats.values && stats.values.length === 0) || (stats.type === 'summary' && stats.total_answers === 0)) {
            return <p className={styles.noData}><FormattedMessage id="answersPage.noAnswers" /></p>;
        }

        switch (stats.type) {
            case 'pie':
                return <Pie data={chartData} options={options} />;
            case 'bar':
                return <Bar data={chartData} options={options} />;
            case 'summary':
                return (
                    <div className={styles.summary}>
                        <div className={styles.summaryValue}>{stats.total_answers}</div>
                        <div className={styles.summaryLabel}><FormattedMessage id="formSettingsPage.stats.submissions" /></div>
                    </div>
                );
            default:
                return <p className={styles.noData}><FormattedMessage id="charts.unsupportedType" /></p>;
        }
    };

    return (
        <Card className={styles.chartCard}>
            <h3 className={styles.questionTitle}>{question_text}</h3>
            <div className={`${styles.chartContainer} ${stats.type === 'summary' ? styles.summaryContainer : ''}`}>
                {renderChart()}
            </div>
        </Card>
    );
};
export default ChartCard;
